import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { storeDevToolsConfig } from './app-store.config';
import { ScreenReduxModule } from './common-data/screen/screen-redux.module';
import { UserPreferenceReduxModule } from './user-preference/user-preference-redux.module';
import { UserReduxModule } from './user/user-redux-module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot({}, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: false,
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictActionWithinNgZone: false,
        strictActionTypeUniqueness: true,
      },
    }),
    ...storeDevToolsConfig(environment.enableDevTools),
    EffectsModule.forRoot([]),
    UserReduxModule,
    UserPreferenceReduxModule,
    ScreenReduxModule,
  ],
})
export class AppStoreModule {}
